// KEY-461: the Items tab paints itself red when its action point isn't fully complete, rather than
// leaving completion buried in the "N of M items complete" chip title nobody hovers to find.

/**
 * How many of a segment's items are still incomplete — zero once every item is done, and zero for a
 * segment with no items at all. An empty segment has nothing to flag, so it is never "incomplete"; that
 * would read as every item having failed rather than none existing yet.
 */
export function itemsTabIncompleteCount(done: number, total: number): number {
  return total > 0 ? Math.max(0, total - done) : 0;
}

/** Whether the Items tab should carry the "danger" tone (KEY-461). */
export function itemsTabIsDangerous(done: number, total: number): boolean {
  return itemsTabIncompleteCount(done, total) > 0;
}

/** The tab's hover/aria hint when it's carrying the danger tone; undefined when it isn't. */
export function itemsTabIncompleteHint(done: number, total: number): string | undefined {
  const missing = itemsTabIncompleteCount(done, total);
  return missing > 0 ? `${missing} of ${total} ${missing === 1 ? "item" : "items"} incomplete` : undefined;
}
